export default {
  ENTITIES: `companies/:company_id/entities`
}